import { getApiServices, TBuildEnv } from './helpers';

export const APIServices = getApiServices(
  process.env.REACT_APP_BUILD_ENV as TBuildEnv
);

export type TAPIService = keyof typeof APIServices;
